import { render, staticRenderFns } from "./changeQuotation.vue?vue&type=template&id=d6da0440&scoped=true&"
import script from "./changeQuotation.vue?vue&type=script&lang=js&"
export * from "./changeQuotation.vue?vue&type=script&lang=js&"
import style0 from "./changeQuotation.vue?vue&type=style&index=0&id=d6da0440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6da0440",
  null
  
)

export default component.exports